import styled from 'styled-components';

export const DataContainer = styled.div`
    background-color: #FFFFFF;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0 7px 30px 0 rgba(82,82,107,0.35);
    display: block;
    height: ${ ({ active, items }) => active ? `${ items * 30 }px` : '0px' };
    max-height: 150px;
    min-width: 250px;
    opacity: ${ ({ active }) => active ? '1' : '0' };
    overflow-y: ${ ({ active, items }) => active && items > 5 ? 'auto' : 'hidden' };
    position: absolute;
    transition: all 0.3s ease;
    z-index: 9;
`;

export const DataLine = styled.div`
    align-items: center;
    color: ${ ({ color, theme: { textColor } }) => color ? color : textColor };
    display: flex;
    font-size: 11px;
    height: 30px;
    padding: 10px;
    position: relative;
    span {
        margin-right: 5px;
    }
`;

export const NamesContainer = styled.div`
    ${ ({ pointer }) => pointer ? 'cursor: pointer;' : '' };
    height: 25px;
`;

export const Text = styled.p`
    color: ${ ({ theme: { textColor } }) => textColor };
    display: inline-block;
    font-size: ${ ({ fontSize }) => fontSize ? fontSize : '11px' };
    margin: 0;
`;
